import { jsx as _jsx } from "react/jsx-runtime";
import { KompisPriceModule } from '@inter-ikea-kompis/react-components';
import { useKompis } from '../contexts';
export default ({ shoppingProducts, productName, layout, children }) => {
    const { dexfAppSettings, translations } = useKompis();
    return (_jsx(KompisPriceModule, { shoppingProducts: shoppingProducts, productName: productName, theme: useKompis().theme, settings: dexfAppSettings, translations: translations.kompis, layout: layout, children: children }));
};
//# sourceMappingURL=KompisPriceModule.js.map